import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteLayout } from "@/components/layout/SiteLayout";

import Home from "@/pages/Home";
import WhatWeSolve from "@/pages/WhatWeSolve";
import Capabilities from "@/pages/Capabilities";
import CapabilityDetail from "@/pages/CapabilityDetail";
import Network from "@/pages/Network";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Heritage from "@/pages/Heritage";
import About from "@/pages/About";
import BringAChallenge from "@/pages/BringAChallenge";
import JoinTheNetwork from "@/pages/JoinTheNetwork";
import Evidence from "@/pages/Evidence";
import SearchPage from "@/pages/SearchPage";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminContent from "@/pages/admin/AdminContent";
import AdminUsers from "@/pages/admin/AdminUsers";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/what-we-solve" element={<WhatWeSolve />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/capabilities/:slug" element={<CapabilityDetail />} />
              <Route path="/network" element={<Network />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:slug" element={<ProjectDetail />} />
              <Route path="/heritage" element={<Heritage />} />
              <Route path="/about" element={<About />} />
              <Route path="/bring-a-challenge" element={<BringAChallenge />} />
              <Route path="/join-the-network" element={<JoinTheNetwork />} />
              <Route path="/evidence" element={<Evidence />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/privacy" element={<Legal variant="privacy" />} />
              <Route path="/terms" element={<Legal variant="terms" />} />
              <Route path="/accessibility" element={<Legal variant="accessibility" />} />
              <Route path="/cookies" element={<Legal variant="cookies" />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="challenges" element={<AdminSubmissions kind="challenge" />} />
              <Route path="applications" element={<AdminSubmissions kind="application" />} />
              <Route path="projects" element={<AdminProjects />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="users" element={<AdminUsers />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
